import React from 'react';
import './styles.scss';
import ImageCredits from '../../AutostadtTabComponents/Tiles/ImageCredits';

interface SubpageWhiteProps {
    title: string;
    subline?: string;
    svg?: string;
    children: JSX.Element;
    imageSrc?: string;
    imageCredits?: string;
    nestedSubpage?: boolean;
}

export default function SubpageWhite({
    imageSrc,
    imageCredits,
    title,
    subline,
    svg,
    children,
    nestedSubpage,
}: SubpageWhiteProps): JSX.Element {
    return (
        <div className='as-subpage white'>
            <section>
                <article>
                    {imageSrc && <ImageCredits image={imageSrc} credits={imageCredits?? ''} />}
                    <div className={`header-white-subpage ${nestedSubpage ? 'nested' : ''}`}>
                        {nestedSubpage ? (
                            <>
                                <h2>{title}</h2>
                                <h3>{subline}</h3>
                                <div className='line' />
                            </>
                        ) : (
                            <>
                                <h1>{title}</h1>
                                {svg && <svg className='icon-24 swipe'>
                                    <use xlinkHref={`#${svg}`} />
                                </svg>}
                                <div className='line' />
                                <p className='body large'>{subline}</p>
                            </>
                        )}
                    </div>
                    {children}
                </article>
            </section>
        </div>
    );
}
